import type { OwnerBookingWithTypeDto } from '@shared/core/bookings'
import type { BookingDetailsField } from './booking-details-section.interface'

export function buildBookingDetailsFields(booking: OwnerBookingWithTypeDto): BookingDetailsField[] {
  const fields: Array<[string, string | null | undefined]> = [
    ['event.bookingDetails.label.appointmentType', booking.appointment_type_name],
    ['event.bookingDetails.label.name', booking.customer_name],
    ['event.bookingDetails.label.phone', booking.customer_phone],
    ['event.bookingDetails.label.email', booking.customer_email],
    ['event.bookingDetails.label.address', booking.customer_address],
  ]
  return fields
    .filter((field): field is [string, string] => Boolean(field[1]?.trim()))
    .map(([messageId, value]) => ({ messageId, value }))
}
